export default __webpack_public_path__ + "static/mitech-client-logo-05-hover-404853efa7f44330916f3f94d9e059b8.png";